const FormButton = ({ className, type, ...props }) => {
  const handleCalculateStyles = () => {
    switch (type) {
      case "primary":
        return props.small ? "continue-button-sm" : "continue-button";
      case "secondary":
        return "back-button";
      case "otp":
        return "btn-get-otp";
      default:
        return props.small ? "continue-button-sm" : "continue-button";
    }
  };

  return (
    <button
      style={{
        minWidth: props.small ? "67px" : "200px",
        fontWeight: "600",
        borderRadius: "1.1em",
        whiteSpace: "nowrap",
        display: "flex",
        justifyContent: "center",
        padding: "0.75em 0.75em",
      }}
      className={`w-100 btn btn-lg ${handleCalculateStyles(type)} ${className}`}
      type="submit"
      {...props}
    >
      {props.children}
    </button>
  );
};

export default FormButton;
